/**************************************************************************************************/
/*   File: /src/app/stores/selectors/ui/selectors.ts                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromShared from '../../../shared';
import * as fromReducers from '../../reducers/ui';
import * as fromState from '../../states/ui';

/**
 * Get the ui state
 */
export const getUiState = createFeatureSelector<fromState.State>('ui');
/**
 * Get languages
 */
export const getLanguages = createSelector(
    getUiState,
    fromReducers.helpers.getLanguages
);
/**
 * Get current language
 */
export const getCurrentLanguage = createSelector(
    getUiState,
    getLanguages,
    (state: fromState.State, languages: fromShared.models.Language[]) => {
        return languages ? languages.find(x => x.selected === true) : undefined;
    }
);
/**
 * Get is loading
 */
export const getIsLoading = createSelector(
    getUiState,
    fromReducers.helpers.getIsLoading
);
/**
 * Get messages
 */
export const getMessages = createSelector(
    getUiState,
    fromReducers.helpers.getMessages
);
/**
 * Get logged user
 */
export const getLoggedUser = createSelector(
    getUiState,
    fromReducers.helpers.getLoggedUser
);
/**
 * Get logged user
 */
export const getIsLoggedUser = createSelector(
    getLoggedUser,
    (user) => {
        return user !== undefined && user.username ? true : false;
    }
);
/**
 * Get the dossier status
 */
export const getDossierStatus = createSelector(
    getUiState,
    fromReducers.helpers.getDossierStatus
);
/**
 * Get the plan types
 */
export const getPlanTypes = createSelector(
    getUiState,
    fromReducers.helpers.getPlanTypes
);
/**
 * Get the ambiti
 */
export const getAmbiti = createSelector(
    getUiState,
    fromReducers.helpers.getAmbiti
);
/**
 * Get geo file types
 */
export const getGeoFileTypes = createSelector(
    getUiState,
    fromReducers.helpers.getGeoFileTypes
);
